<label [for]="id" [ngClass]="['control-label', _labelClass]">Parc(s)&nbsp;:</label>
<div [ngClass]="_fieldClass">
	<multi-filterable-select
		[id]="id"
		[list]="parcs"
		[labelGetter]="getParcLabel"
		[changeSelectionCommands]="changeSelectionCommands"
		(selectedItemsChange)="onSelectedParcsChange($event)"
		>
	</multi-filterable-select>
</div>